






































































































































import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import PeriodPicker from '@/components/PeriodPicker';
import ChangePriceBlock from '@/components/ChangePriceBlock';
import TotalInformationCard from '@/components/TotalInformationCard';
import {mapActions, mapGetters} from 'vuex';
import { changeTermsRentAdRequest } from '@/services/api';

@Component({
  name: 'ChangeTerms',
  components: {
    PeriodPicker,
    ChangePriceBlock,
    TotalInformationCard,
  },
  created() {},
  props: {
    apartment: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      datePicker: '',
      showDatePicker: false,
      errorPrice: false,
      userPrice: null,
      actualEndDate: this.endDate,
      startDate: new Date().toISOString().substring(0, 10),
      showThankModal: false,
      errorProlong: '',
    };
  },
  computed: {
    ...mapGetters('profile', ['changeTermsTexts']),
    ...mapGetters(['language']),
    minDate() {
      return this.apartment && this.apartment.lease_contract
          ? this.apartment.lease_contract.end
          : this.startDate;
    },

    endDate: {
      get() {
        return this.actualEndDate ? this.actualEndDate
            : this.apartment?.rent_ad_request ? this.apartment.rent_ad_request.end
            : new Date().toISOString().substring(0, 10);
      },
      set(value) {
        this.actualEndDate = value;
      },
    },
  },
  methods: {
    ...mapActions(['showCentralAlert']),
    changeUserPrice(value) {
      this.userPrice = value;
      this.errorPrice = false;
    },
    sendNewTerms() {
      const actualPrice = this.userPrice
          ? this.userPrice
          : this.apartment?.rent_ad_request?.price ?? this.apartment?.recommended_price;
      if (actualPrice >= this.apartment.recommended_price) {
        const data = {
          id: this.apartment.rent_ad_request.id,
          value: {
            price: actualPrice,
            end: this.actualEndDate,
          },
        };
        changeTermsRentAdRequest(data)
            .then((response) => {
              if (response.status === 200) {
                this.showThankModal = true;
              } else if (response.status === 400 || response.status > 401) {
                (this as any).errorProlong = response.data?.mobile_errors[0].messages[0];
              }
            })
            .catch((error) => {
              console.log(error);
            });
      } else {
        this.errorPrice = true;
      }
    },
  },
})
export default class ChangeTerms extends Vue {}
